<!--<template>
<div id="ag-grid-demo">
    <vx-card style="padding-top:10px">
        <vs-row>
            <vs-col class="w-1/2">
                <div class="dropdown">
                    <a class="flex items-center" href.prevent>
                        <vs-button type="border" @click="filterShow^=true">Filter</vs-button>
                    </a>
                    <div class="dropdown-content" v-if="filterShow">
                        <div class="vx-row">&nbsp;</div>
                        <vs-row class=" mb-4" style="margin-left:1%;">
                            <vs-col class=" sm:w-1/12 w-full topPad">
                                <span class="inputStyles">From</span>
                            </vs-col>
                            <vs-col class=" sm:w-1/3 w-full">
                                <flat-pickr v-model="fromDate" placeholder="From Date" />
                            </vs-col>
                            <vs-col class=" sm:w-1/12 w-full topPad" style="margin-left:15px">
                                <span class="inputStyles">To</span>
                            </vs-col>
                            <vs-col class=" sm:w-1/3 w-full">
                                <flat-pickr v-model="toDate" placeholder="To Date" />
                            </vs-col>
                        </vs-row>
                        <vs-col class="w-1/2">
                            <div align="left">
                                <vs-button color="success" type="border" @click="clear">Clear</vs-button>
                            </div>
                        </vs-col>
                        <vs-col class="w-1/2">
                            <div align="right">
                                <vs-button color="success" type="gradient" @click="onGridReady">Apply</vs-button>
                            </div>
                        </vs-col>

                    </div>
                </div>
            </vs-col>
            <vs-col class="w-1/2">
                <vs-row class="mb-4 1/6" style="margin-left:80%;">
                    <vs-col class=" sm:w-1/12 w-full">
                        <img src="@/assets/images/logo/pdf.jpg" style="cursor:pointer" @click="getPdfReport" width="35px" height="35px;" />
                    </vs-col>
                    <vs-col class=" sm:w-1/6 w-full">
                        <img src="@/assets/images/logo/xcl.png" style="cursor:pointer" @click="getExcelReport" width="35px" height="35px;" />
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="contacts" @grid-ready="onGridReady" :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true">
        </ag-grid-vue>
        <vs-pagination style="margin-top:-60px;" :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
    </vx-card>
</div>
</template>-->
<template>
  <div id="bill-report-page">
    <vx-card class="cHeight">

      <!-- FROM DATE -->
      <vs-row class="mb-6">
        <vs-col class="w-1/6 topPad">
          <span class="label">From Date</span>
        </vs-col>

        <vs-col class="w-1/4">
          <flat-pickr v-model="fromDate" :config="dateConfig" class="w-full inputField" />
        </vs-col>
      </vs-row>

      <!-- TO DATE -->
      <vs-row class="mb-6">
        <vs-col class="w-1/6 topPad">
          <span class="label">To Date</span>
        </vs-col>

        <vs-col class="w-1/4">
          <flat-pickr v-model="toDate" :config="dateConfig" class="w-full inputField" />
        </vs-col>
      </vs-row>
    <!-- BILL TYPE -->
<vs-row class="mb-6">
  <vs-col class="w-1/6 topPad">
    <span class="label">Bill Type</span>
  </vs-col>

  <vs-col class="w-1/4">
    <vs-select v-model="billType" class="w-full">
      <vs-select-item
        v-for="item in billTypeList"
        :key="item.typeId"
        :value="item.typeId"
        :text="item.typeName"
      />
    </vs-select>
  </vs-col>
</vs-row>
      <!-- EXPORT TYPE -->
      <vs-row class="mb-6">
        <vs-col class="w-1/6 topPad">
          <span class="label">Export Type</span>
        </vs-col>

        <vs-col class="w-2/3">
          <vs-radio v-model="reportType" vs-value="PDF">PDF</vs-radio>
          <vs-radio v-model="reportType" vs-value="EXCEL" style="margin-left:20px">Excel</vs-radio>
        </vs-col>
      </vs-row>

      <!-- BUTTONS -->
      <vs-row style="margin-top:40px;">
        <vs-col class="w-full sm:w-1/6"></vs-col>

        <vs-col class="w-full sm:w-1/3">
          <vs-button @click="generateReport" style="margin-right:20px;">
            Preview
          </vs-button>

          <vs-button @click="clearForm">
            Clear
          </vs-button>
        </vs-col>
      </vs-row>

    </vx-card>
  </div>
</template>

<script>
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
export default {
components:{

flatPickr
},
  data() {
    return {
      fromDate: null,
      toDate: null,
      reportType: 'PDF',
      billType: "0",         
      billTypeList: [], 
      dateConfig: {
        dateFormat: "d-m-Y"
      }
    }
  },
    mounted() {
  this.getBillTypes();
},
  methods: {

    formatDate(date) {
      if (!date) return null;  
      return date.split('-').reverse().join('-');
    },
     async getBillTypes() {
  try {
    const request = {
      companyId: this.$session.get("companyId"),
    };

    const response = await this.$http.post(
      "getbilltypes",
      JSON.stringify(request),
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    this.billTypeList = response.data.data;

    console.log("Bill Types:", this.billTypeList); 
    this.billTypeList = response.data.data.map(item => {
  if (item.typeId === "0") {
    return {
      typeId: "0",
      typeName: "ALL"   
    };
  }
  return item;
});
  } catch (error) {
    console.error("Error fetching bill types:", error);
  }
},
    clearForm() {
      this.fromDate = null;
      this.toDate = null;
      this.reportType = 'PDF';
    },

    generateReport() {
      if (this.reportType === 'PDF') {
        this.getPdfReport();
      } else {
        this.getExcelReport();
      }
    },

    getPdfReport() {
      var request = {
        companyId: this.$session.get('companyId'),
        filter: {
          dateFrom: this.formatDate(this.fromDate),
          dateTo: this.formatDate(this.toDate),
           billType: this.billType
        }
      };

      console.log("PDF REQUEST", request); // 👈 debug

      this.$http.post("getbillreportpdf", JSON.stringify(request), {
        headers: { "Content-Type": "application/json" }
      })
      .then(response => {
        window.open(response.data.data.filePath);
      });
    },

    getExcelReport() {
      var request = {
        companyId: this.$session.get('companyId'),
        filter: {
          dateFrom: this.formatDate(this.fromDate),
          dateTo: this.formatDate(this.toDate)
        }
      };

      console.log("EXCEL REQUEST", request); // 👈 debug

      this.$http.post("getbillreportxls", JSON.stringify(request), {
        headers: { "Content-Type": "application/json" }
      })
      .then(response => {
        window.open(response.data.data.filePath);
      });
    }
  }
}

</script>
<style scoped>
.cHeight {
  min-height: 80vh;   
}
.inputField {
  height: 36px;
  width: 100%;
}
.label {
  font-size: 13.2px;
  font-weight: 600;
  padding-top: 6px;
  display: inline-block;
}
</style>
<!-- {
    AgGridVue
} from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    components: {
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            filterShow: false,
            fromDate: null,
            toDate: null,
            gridOptions: {
                rowModelType: 'infinite',
                rowStyle: {
                    'text-align': 'center'
                }
            },
            maxPageNumbers: 7,
            gridApi: null,
            components: null,
            defaultColDef: {
                sortable: false,
                resizable: true,
                suppressMenu: true,
            },
            columnDefs: [{
                    headerName: 'SrNo',
                    field: 'srNo',
                    width: 76,
                },
                {
                    headerName: 'Date',
                    field: 'billDate',
                    width: 154,
                },
                {
                    headerName: 'Bill No',
                    field: 'billId',
                    width: 90,
                },
                {
                    headerName: 'Name',
                    field: 'patientName',
                    width: 268,
                    cellStyle: {
                        'text-align': 'left'
                    }
                },
                {
                    headerName: 'Bill Amount',
                    field: 'billAmount',
                    width: 141,
                },
                {
                    headerName: 'Received Amount',
                    field: 'receivedAmount',
                    width: 142,
                },
                {
                    headerName: 'Bill Due',
                    field: 'billDue',
                    width: 140,
                },

            ],
            contacts: [{}],
        }
    },

    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize()
            else return 8
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages()
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
                this.onGridReady()
            }
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.gridApi.sizeColumnsToFit();
    },

    methods: {
        clear() {
            this.fromDate = null;
            this.toDate = null;
        },
        onGridReady(params) {
          
            this.gridApi.showLoadingOverlay();
            window.addEventListener("resize", function () {
                setTimeout(function () {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
            this.filterShow = false;
            var request = {
                companyId: this.$session.get('companyId'),
                currentPage: this.gridApi.paginationGetCurrentPage() + 1,
                limit: this.gridApi.paginationGetPageSize(),
                filter: {
                    dateFrom: this.fromDate,
                    dateTo: this.toDate
                }
            }

            var datasource = {
                getRows: (params) => {
                    this.$http.post(
                            "getbillreports",
                            JSON.stringify(request), {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        .then(response => {
                            params.successCallback(response.data.data.records, response.data.data.recordsTotal);
                            this.gridApi.hideOverlay();

                        });

                }
            }
            this.gridApi.setDatasource(datasource);
        },
        getExcelReport() {

            var request = {
                companyId: this.$session.get('companyId'),
                filter: {
                    dateFrom: this.fromDate,
                    dateTo: this.toDate
                }
            }
            this.$http.post(
                    "getbillreportxls",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    console.log("excel",response.data);

                    window.open(response.data.data.filePath);
                });
        },
        getPdfReport() {
            var request = {
                companyId: this.$session.get('companyId'),
                filter: {
                    dateFrom: this.fromDate,
                    dateTo: this.toDate
                }
            }
            this.$http.post(
                    "getbillreportpdf",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    console.log("pdf",response.data);

                    window.open(response.data.data.filePath);
                });
        }
    },

}
</script>

<style scoped>
.dropdown-content {
    position: absolute;
    background-color: #f9f9f9;
    min-width: 680%;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    padding: 12px 16px;
    z-index: 1;
}

.dropdown {
    position: relative;
    display: inline-block;
}

.ag-header-cell-label {
    justify-content: center;
}
.inputStyles{
    font-size: 11.8px;
    font-weight: 600;
}
.topPad{
    padding-top: 7px;
}
</style>-->

